import { formatNumber } from "../format"
import { TextCell } from "./text-cell"

type Props = {
  value: number | null | undefined
  align?: "left" | "right" | "center"
}

// Numeric cells right-align by default — matches finance / table-of-numbers
// convention so columns line up on the decimal.
export function NumberCell({ value, align = "right" }: Props) {
  return <TextCell value={formatNumber(value)} align={align} mono />
}
